var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "appfade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.appIsLoaded,
            expression: "appIsLoaded"
          }
        ],
        staticClass: "generic-page--template page-template"
      },
      [
        _c("div", { staticClass: "db relative center z-0 w-100 h-auto" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c(
              "section",
              { staticClass: "db relative center mw8 tc pt5 pt6-ns pb5" },
              [
                _c(
                  "h3",
                  { staticClass: "tc mv4 ttu is-bebas is-white page-title" },
                  [_vm._v(_vm._s(_vm.page.title))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "db relative center mw8 br2" }, [
                  _c(
                    "div",
                    { staticClass: "row middle-sm mv3 mv4-ns" },
                    _vm._l(_vm.page.Partners, function(partner) {
                      return partner.is_published
                        ? _c(
                            "div",
                            { staticClass: "col-xs-6 col-sm-4 center" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "flex relative center flex-row items-center w-100 mv0 aspect-ratio--1x1 bg-center pointer br2",
                                  attrs: {
                                    href: partner.link,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "db absolute center left-0 right-0 abs-vert-center img-responsive ph2 mw5-ns",
                                    attrs: {
                                      src: partner.image,
                                      "data-src": partner.image
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ])
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }